import React from 'react';

import { UserRole } from '@appUtils/tripConverter';
import UserRoleList from '../UserRoleList';

const Managers = () => <UserRoleList role={UserRole.MANAGER} withActions />;

export default Managers;
